export default "__VITE_ASSET__DTMY$Vcx__"